<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="pt-2">
    <div class="col-sm-12 nopads px-2">
      <work-time-search ref="searchView" @search="searchWithParams"/>
      <hr/>
      <div class="col-sm-12 d-flex justify-content-end p-2">
        <button v-if="results && results.length > 0" class="btn btn-outline-success form-button" @click="exportExcel"
        >
          {{ $t('common.download_excel') }}
        </button>
        <button class="btn btn-success form-button" @click="addItem">
          {{ $t('common.add_new') }}
        </button>
      </div>

      <base-modal
        v-if="editMode"
        hide-footer
        hide-header
        @close="showList"
      >
        <daily-allowance-editor
          :daily-allowance="result"
          :is-observer="isObserver"
          style="width: 100% !important;"
          @close-and-update="search"
          @close="showList"
        />
      </base-modal>

      <div class="col-sm-12 list-container nopads">
        <div v-if="resultList.length > 0" class="list-content result-table">
            <vue3-datatable
                ref="resultTable"
                :rows="resultList"
                :columns="fields"
                :pagination="false"
                :sticky-header="true"
                height="60vh"
                :sortable="true"
                skin="bh-table-compact"
                row-class="routa-table-row"
                cell-class="routa-table-cell"
                @row-click="editItem"
            >
                <template
                    #start_time="row"
                >
                    <span>{{ row.value.start_time ? toLocalTime(row.value.start_time) : '' }}</span>
                </template>
                <template
                    #end_time="row"
                >
                    <span>{{ row.value.end_time ? toLocalTime(row.value.end_time) : '' }}</span>
                </template>
            </vue3-datatable>
        </div>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import WorkTimeSearch from '../worktime/WorkTimeSearch'
import {timeUtils} from '../mixins/TimeUtils'
import {allowanceHelper} from '../mixins/AllowanceMixin'
import BaseModal from "@/components/BaseModal";
import DailyAllowanceEditor from './DailyAllowanceEditor'
import {downloadHelper} from '../mixins/DownloadMixin'
import {inject} from "vue";
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'DailyAllowances',
    components: {Vue3Datatable, WorkTimeSearch, DailyAllowanceEditor, BaseModal},
    mixins: [restApi, timeUtils, allowanceHelper, downloadHelper],
    props: {
        isObserver: Boolean
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            searchParams: [],
            editMode: false,
            results: [],
            resultList: [],
            result: null,
            sortBy: 'start_time',
            sortDesc: false,
            fields: [
                {field: 'user', title: this.$t('daily_allowance.user'), sort: true, headerClass: 'routa-table-header'},
                {field: 'start_time', title: this.$t('work_report.start_time'), sort: true, headerClass: 'routa-table-header'},
                {field: 'start_place', title: this.$t('work_time.start_location'), sort: true, headerClass: 'routa-table-header'},
                {field: 'end_time', title: this.$t('work_report.end_time'), sort: true, headerClass: 'routa-table-header'},
                {field: 'end_place', title: this.$t('work_time.end_location'), sort: true, headerClass: 'routa-table-header'},
                {field: 'full_allowances', title: this.$t('daily_allowance.full'), sort: true, headerClass: 'routa-table-header'},
                {field: 'partial_allowances', title: this.$t('daily_allowance.partial'), sort: true, headerClass: 'routa-table-header'},
                {field: 'info', title: this.$t('work_report.info'), sort: false, headerClass: 'routa-table-header'},
                {field: 'approver', title: this.$t('daily_allowance.approver'), sort: true, headerClass: 'routa-table-header'}
            ]
        }
    },
    watch: {
        results() {
            // Convert to table items
            let temp = []
            this.resultList = []
            this.results.forEach(item =>
                temp.push({
                    ...item,
                    'user': item.user ? item.user.first_name + ' ' + item.user.last_name : '',
                    'start_time': item.start_time,
                    'end_time': item.end_time,
                    'start_place': item.start_place ? item.start_place : '',
                    'end_place': item.end_place ? item.end_place : '',
                    'full_allowances': item.full_allowances ? item.full_allowances : '',
                    'partial_allowances': item.partial_allowances ? item.partial_allowances : '',
                    'info': item.info,
                    'approver': item.approver ? item.approver.first_name + ' ' + item.approver.last_name : '',
                })
            )
            this.$nextTick(() => this.resultList = temp )
        }
    },

    mounted() {
        this.searchParams = this.$refs.searchView.getSearchParams()
    },

    methods: {
        search() {
            this.results = []
            this.loading = true
            this.restFetchParams(this.dailyAllowanceUrl, this.searchParams, this.handleResponse)
        },

        searchWithParams: function (params) {
            this.searchParams = params
            this.search()
        },
        handleResponse: function (response) {
            this.loading = false
            this.results = response.data
            this.showList()
        },
        showList: function () {
            this.editMode = false
        },
        editItem: function (item) {
            this.result = this.results.find(res => res.id === item.id)
            this.editMode = true
        },
        addItem: function () {
            this.result = null
            this.editMode = true
        },
        exportExcel: function () {
            this.loading = true
            this.restGetDownloadFile(this.dailyAllowanceReportUrl, this.getCommonReportParams(this.searchParams), this.fileDownloadSuccess, this.fileDownloadFail)
        },
        fileDownloadSuccess: function (response) {
            this.loading = false
            this.downloadFile(response, this.$t('daily_allowance.report_file_name'))
        },
        fileDownloadFail: function () {
            this.loading = false
            this.showAlert(this.$t('common.report_generation_failed'))
        }
    }
}
</script>
